import { COUNTRIES } from "../constants/countries";

export const getCountryData = (code) => {
  return COUNTRIES.find((c) => c.code === code);
};